const map = {
	"./IMG_3796.webp": 5005,
	"./IMG_3797.webp": 2242,
	"./IMG_3798.webp": 807,
	"./IMG_3799.webp": 8948,
	"./IMG_3801.webp": 4460,
	"./IMG_3805.webp": 3120
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6979;